import { DocumentType } from './types';
import { getSchema } from './analytics-events.utils';
import transformObjectKeys from 'transform-object-keys';

// https://github.com/Upheal/upheal-analytics/tree/main/schemas/io.upheal/segments/jsonschema
export type SegmentProps<Action extends string = string> = {
    segmentId: string;
    action?: Action | null;

    /**
     * @deprecated - not used anymore
     */
    bookmark: boolean | null;
    editorType: string | null;
    contentType: string;
    content?: string | null; // Send content only in case we have client's optional consent to send it
    inaccurate?: boolean | null;
    order?: string | null;
    sourceDocument?: {
        documentId: string;
        documentType: string;
        segmentId?: string | null;
        sourceStartIndex?: number | null;
        sourceEndIndex?: number | null;
    };
};

export type SegmentsProps<Action extends string = string> = {
    documentId: string;
    documentType: DocumentType;
    segments: Array<SegmentProps<Action>>;
};

export const getSegmentsContext = (props: SegmentsProps) => {
    return {
        schema: getSchema('segments', '2-0-0'),
        data: transformObjectKeys(props, { snakeCase: true, deep: true }),
    };
};
